export default "__VITE_ASSET__tDctIz0K__"